module.exports = __webpack_public_path__ + "static/avatar-df9a4542382345eadabb98b5d090864e.png";